module.exports = __webpack_public_path__ + "static/media/_trials_list.a7ca2abf.svg";